module.exports = __webpack_public_path__ + "payment-invoices-card-icon.png?6a42c549d4e71afb51f3a1b3b7f9e400";